import { createSelector } from "@reduxjs/toolkit";

const importDataSelector = createSelector(
  (state) => state.importData,
  (a) => a
);

export default importDataSelector;
